import React from 'react';
import { dialogConfirm } from '../../components/elements/Dialog/dialogs';
import I18nString from '../../components/elements/I18nString';
import { getPushNotificationsClientInstance } from './getPushNotificationsClientInstance';
import translations from './push-notifications.i18n.csv';
import styles from './pushNotifications.module.scss';
import { registerPermissionRequest } from './storage';

/**
 * Asks the user for permission to receive push notifications.
 *
 * @returns {Promise<Boolean>} Whether the user granted the permission.
 */
export async function askPermission() {
    const askBrowserPermission = await dialogConfirm(
            <>
                <p>
                    <I18nString localI18n={translations}>pushnotifications.permissiondialog.description.p1</I18nString>
                </p>
                <p>
                    <I18nString localI18n={translations}>pushnotifications.permissiondialog.description.p2</I18nString>
                </p>
            </>,
            <I18nString localI18n={translations}>pushnotifications.permissiondialog.title</I18nString>,
            <I18nString localI18n={translations}>pushnotifications.permissiondialog.option.accept</I18nString>,
            <I18nString localI18n={translations}>pushnotifications.permissiondialog.option.ignore</I18nString>,
            {
                className: styles.permissionDialog,
                visibleClassName: styles.visibleDialog,
                hiddenClassName: styles.hiddenDialog,
            }
        ),
        client = getPushNotificationsClientInstance();

    registerPermissionRequest();

    return askBrowserPermission && (await client.requestPermission());
}
